const postAddDocumentCompanies = {
  toastr: 'Documento adicionado',
  toastr: 'O documento foi adicionado com sucesso'
};

export default postAddDocumentCompanies;
